import { LorumLogoMark } from "./lorum-logo";

import "./css/logo.css";

export function FullScreenLoader() {
	return (
		<div className="full-screen-loader" data-testid="full-screen-loader">
			<LorumLogoMark className="fuse-loader" />
		</div>
	);
}
